import { storageGetAll } from "./storage.js";
// One-file backup of everything in chrome.storage.local — the user's
// data belongs to them (Kernel; D-017 rider: export works even while a
// subscription is lapsed). Shared by Settings and the license gate.

export async function exportBackup(): Promise<void> {
  const all = await storageGetAll();
  delete (all as Record<string, unknown>)["snipSource"];
  const blob = new Blob([JSON.stringify(all)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `TickAhead-backup-${new Date().toISOString().slice(0, 10)}.json`;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}
